import { useState } from 'react';
import { Select, type SelectProps } from 'antd';
import { useListCounterpartiesQuery } from '../api/counterpartyApi';

/** Уже выбранный контрагент: архивного нет в списке выбора — без подписи поле показало бы
 * технический идентификатор вместо названия. */
export interface CurrentCounterparty {
  id: string;
  name: string;
  isArchived?: boolean;
}

export interface CounterpartySelectProps {
  value?: string;
  onChange: (id: string | undefined) => void;
  /** Название выбранного контрагента — подставляется в список, если его там нет. */
  current?: CurrentCounterparty;
  disabled?: boolean;
  placeholder?: string;
  /** Скрыть эту карточку из списка (например, саму себя при выборе дубликата для «Объединить с…»). */
  excludeId?: string;
}

export function CounterpartySelect({ value, onChange, current, disabled, placeholder = 'Контрагент', excludeId }: CounterpartySelectProps) {
  const [q, setQ] = useState('');
  const { data = [], isFetching } = useListCounterpartiesQuery({ q: q || undefined });

  const handleChange: SelectProps<string>['onChange'] = (id) => onChange(id);

  const options = data.filter((c) => c.id !== excludeId).map((c) => ({ value: c.id, label: c.name, disabled: false }));
  if (current && current.id === value && !data.some((c) => c.id === current.id)) {
    options.unshift({ value: current.id, label: current.isArchived ? `${current.name} (в архиве)` : current.name, disabled: !!current.isArchived });
  }

  return (
    <Select<string>
      value={value}
      allowClear
      showSearch
      filterOption={false}
      disabled={disabled}
      loading={isFetching}
      placeholder={placeholder}
      style={{ width: '100%', minWidth: 220 }}
      onSearch={setQ}
      onChange={handleChange}
      options={options}
    />
  );
}
